export const IS_EMBEDDED = window.self !== window.top;
